/**
 * Copyright (c) 2023 Gitpod GmbH. All rights reserved.
 * Licensed under the GNU Affero General Public License (AGPL).
 * See License.AGPL.txt in the project root for license information.
 */

import { cn } from "@/components/podkit/lib/cn";
import { MoreHorizontal } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent } from "./DropDown";
import type React from "react";
import { type FC, type PropsWithChildren } from "react";
import { Button } from "@/components/podkit/buttons/Button";

export const DropdownActions: FC<
    { button?: React.ReactNode; onOpenChange?: (open: boolean) => void } & PropsWithChildren
> = ({ button, children, onOpenChange }) => {
    return (
        <DropdownMenu onOpenChange={onOpenChange}>
            {/* Todo: finally move the styles out of index.css */}
            <DropdownMenuTrigger asChild className="flex rounded-md bg-transparent p-1 hover:bg-surface-tertiary">
                {button ? (
                    button
                ) : (
                    <Button variant="ghost" size="icon">
                        <MoreHorizontal className={cn("h-6 w-6 rounded-md p-0.5 text-content-primary")} />
                    </Button>
                )}
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="focus-visible:ring-0">
                {children}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
